import { lazy } from "react";
const SiteData = [
  {
    exact: true,
    path: "/admin/:webmasterTitle/topics",
    acl: "view-topics",
    component: lazy(() => import("@src/views/BackOffice/smartend/topicList")),
  },
  {
    path: "/admin/:webmasterTitle/sections",
    acl: "view-sections",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/sectionList/SectionTable")
    ),
  },
  {
    exact: true,
    path: "/admin/list/:webmasterTitle/comment",
    acl: "view-topic-comments",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/comments/CommentTable")
    ),
  },

  {
    path: "/admin/videos",
    acl: "view-videos",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/videos/VideoTable")
    ),
  },
  {
    exact: true,
    path: "/admin/video/comments",
    acl: "view-videos-comments",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/videos/CommentTable")
    ),
  },
  {
    exact: true,
    path: "/admin/video/:id/comment",
    acl: "view-comments-video-id",
    component: lazy(() =>
      import("@src/views/BackOffice/multimedia/videos/Comments")
    ),
  },
  {
    exact: true,
    path: "/admin/:webmasterTitle/comment",
    acl: "view-comments-topic-id",
    search: "/?topicId=:id",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/comments/Comments")
    ),
  },
  {
    exact: true,
    path: "/admin/add/:webmasterTitle/topics",
    acl: "add-topic",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/topicList/NewTopic")
    ),
  },
  {
    exact: true,
    path: "/admin/:webmasterTitle/topics/:id",
    acl: "edit-topic",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/topicList/EditTopic")
    ),
  },
  {
    exact: true,
    path: "/admin/WebsiteSettings/banners",
    acl: "view-banners",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/Banner/BannerTable")
    ),
  },
  {
    exact: true,
    path: "/admin/WebsiteSettings/menus/list",
    acl: "view-menus-list",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/menus/MenuTable")
    ),
  },
  {
    exact: true,
    path: "/admin/WebsiteSettings/menus/menus_drag",
    acl: "view-menus-drag",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/menus/dragAndDrop")
    ),
  },
  {
    exact: true,
    path: "/admin/WebsiteSettings/contact",
    acl: "view-contact",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/WebsiteContact/Contact")
    ),
  },
  {
    exact: true,
    path: "/admin/WebsiteSettings/personnalisation",
    acl: "view-personnalisation",
    component: lazy(() =>
      import("@src/views/BackOffice/smartend/websiteSettings/Settings")
    ),
  },
  // {
  //   exact: true,
  //   path: "/admin/WebsiteSettings/widgets",
  //   acl: "view-widgets-list",
  //   component: lazy(() =>
  //     import(
  //       "@src/views/BackOffice/smartend/widgetsfile/weatherWidget/WidgetsTable"
  //     )
  //   ),
  // },
  // {
  //   exact: true,
  //   path: "/admin/WebsiteSettings/widgets/holydays",
  //   acl: "view-holidays",
  //   component: lazy(() =>
  //     import(
  //       "@src/views/BackOffice/smartend/widgetsfile/holidayWidget/HolidayWidget"
  //     )
  //   ),
  // },
  // {
  //   exact: true,
  //   path: "/admin/WebsiteSettings/widgets/Weather",
  //   acl: "view-weather",
  //   component: lazy(() =>
  //     import(
  //       "@src/views/BackOffice/smartend/widgetsfile/weatherWidget/WeatherWidget"
  //     )
  //   ),
  // },
  // {
  //   exact: true,
  //   path: "/admin/WebsiteSettings/widgets/list",
  //   acl: "view-widgets",
  //   component: lazy(() =>
  //     import(
  //       "@src/views/BackOffice/smartend/widgetsfile/listwidgets/Listwidgets"
  //     )
  //   ),
  // },
  // {
  //   exact: true,
  //   path: "/admin/WebsiteSettings/widgets/horoscop",
  //   acl: "view-horoscop",
  //   component: lazy(() =>
  //     import(
  //       "@src/views/BackOffice/smartend/widgetsfile/horoscopWidget/Horoscop"
  //     )
  //   ),
  // },
  // {
  //   exact: true,
  //   path: "/admin/WebsiteSettings/widgets/currency",
  //   acl: "view-currency",
  //   component: lazy(() =>
  //     import(
  //       "@src/views/BackOffice/smartend/widgetsfile/currencysWidget/CurrencyWidget"
  //     )
  //   ),
  // },
  {
    exact: true,
    path: "/admin/streamMonitor/table",
    acl: "view-stream-monitor-table",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/StreamMonitor/StreamMonitorTable/sourcesList"
      )
    ),
  },
  {
    exact: true,
    path: "/admin/streamMonitor/stats",
    acl: "view-stream-monitor-stat",
    component: lazy(() =>
      import("@src/views/BackOffice/StreamMonitor/stats/AudienceStats")
    ),
  },
  {
    exact: true,
    path: "/admin/quizz/quizzlist",
    acl: "view-votes",
    component: lazy(() =>
      import("@src/views/BackOffice/vote/quizzList/ListQuizz")
    ),
  },
  {
    exact: true,
    path: "/admin/quizz/questionlist",
    acl: "view-questions",
    component: lazy(() =>
      import("@src/views/BackOffice/vote/questionList/QuestionList")
    ),
  },
  {
    exact: true,
    path: "/admin/quizz/quizzlist/:id/:name",
    acl: "view-quizz-id",
    component: lazy(() =>
      import("@src/views/BackOffice/vote/quizzList/QuestionByQuizzId")
    ),
  },
  {
    exact: true,
    path: "/admin/quizz/optionsList",
    acl: "view-answers",
    component: lazy(() =>
      import("@src/views/BackOffice/vote/optionList/OptionsList")
    ),
  },
  {
    exact: true,
    path: "/admin/quizz/quizzlist/questions/:id",
    acl: "view-question-id",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/vote/optionsByQuestionID/OptionsByQustionsId"
      )
    ),
  },
  {
    exact: true,
    path: "/admin/quizz/questionlist/answers/:id",
    acl: "view-answers-id",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/vote/optionsByQuestionID/OptionsByQustionsId"
      )
    ),
  },
  {
    exact: true,
    path: "/admin/WebsiteSettings/widgets/List/item/:id",
    acl: "view-widgets-id",
    component: lazy(() =>
      import(
        "@src/views/BackOffice/smartend/widgetsfile/listwidgets/WidgetsInfo"
      )
    ),
  },
  {
    exact: true,
    path: "/admin/WebsiteSettings/frontoffice_template",
    acl: "view-templates-frontoffice",
    component: lazy(() =>
      import("@src/views/BackOffice/templates/frontoffice")
    ),
  },

  {
    exact: true,
    path: "/admin/WebsiteSettings/frontoffice_template/:id",
    acl: "view-frontoffice-template-id",
    component: lazy(() =>
      import("@src/views/BackOffice/templates/frontoffice/template_by_id")
    ),
  },
  {
    exact: true,
    path: "/admin/vote/workflow",
    acl: "view-vote-workflow",
    component: lazy(() =>
      import("@src/views/BackOffice/vote/quizzWorkflow/QuizzWorkflow")
    ),
  },
  {
    exact: true,
    path: "/admin/quizz/workflow",
    acl: "view-quiz-workflow",
    component: lazy(() => import("@src/views/BackOffice/Quiz/QuizzesWorkflow")),
  },
  {
    exact: true,
    path: "/admin/Quiz/quizList",
    acl: "view-quiz-list",
    component: lazy(() =>
      import("@src/views/BackOffice/Quiz/quizList/QuizList")
    ),
  },
  {
    exact: true,
    path: "/admin/Quiz/quizItem/:id",
    acl: "view-quizz-id",
    component: lazy(() =>
      import("@src/views/BackOffice/Quiz/quizItem/quizItem")
    ),
  },
];

export default SiteData;
